import { RESET } from '../actionTypes';
import { createAttachmentModalActions } from '../reducer';

export default () => createAttachmentModalActions[RESET]();
